import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

interface ExpandableNoteProps {
  title: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
}

export const ExpandableNote: React.FC<ExpandableNoteProps> = ({
  title,
  children,
  defaultExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div
      style={{
        marginTop: "25px",
        padding: "14px 16px",
        backgroundColor: "#f8fafc",
        borderLeft: "4px solid #4987ef",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          cursor: "pointer",
          userSelect: "none",
        }}
      >
        <strong style={{ fontSize: "15px", color: "#223e7f" }}>{title}</strong>
        {expanded ? (
          <FaChevronUp size={16} color="#223e7f" />
        ) : (
          <FaChevronDown size={16} color="#223e7f" />
        )}
      </div>

      {expanded && (
        <div
          style={{
            marginTop: "10px",
            fontSize: "14.2px",
            lineHeight: "1.6",
            color: "#333",
            paddingLeft: "2px",
            animation: "fadeIn 0.2s ease-in-out",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};
